import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import SentryErrorBoundary from '../SentryErrorBoundary';

const PublicCreateBooking = Loadable(lazy(() => import('views/public-booking-pages/create-booking')));
const ViewSurveyObject = Loadable(lazy(() => import('views/public/view-survey-object')));

// ==============================|| Public Booking ROUTING ||============================== //

const PublicBookingRoutes = {
  path: '/',
  element: <MinimalLayout />,
  errorElement: <SentryErrorBoundary />,
  children: [
    {
      path: '/booking-page/:bookingPageUid',
      element: <PublicCreateBooking />
    },
    {
      path: '/view-survey-object',
      element: <ViewSurveyObject />
    }
  ]
};

export default PublicBookingRoutes;
